/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { ToastrModule } from 'ngx-toastr';
import localeEsCL from '@angular/common/locales/es-CL';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AppComponent } from './app/app.component';
import { KeycloakService } from './app/services/keycloak.service';
import { environment } from './environments/environment';
import { routes } from './app/app.routes';
import { jwtInterceptorFn } from './app/core/interceptors/auth.interceptor';
// Elimina el <title>Chart</title> que ApexCharts inyecta en el SVG
// y que el navegador muestra como tooltip nativo al hacer hover.
// window.Apex es el objeto de configuración global de ApexCharts.
const removeSvgTitle = (chartCtx: any) => {
  chartCtx.el?.querySelectorAll?.('title').forEach((el: Element) => el.remove());
};
(window as any).Apex = {
  chart: {
    events: {
      mounted: removeSvgTitle,
      updated: removeSvgTitle,
    },
  },
};

const keycloakService = new KeycloakService();
registerLocaleData(localeEsCL);

keycloakService.init().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(withInterceptors([jwtInterceptorFn])),
      provideRouter(routes),
      provideAnimations(),
      { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
      { provide: KeycloakService, useValue: keycloakService },
      { provide: LOCALE_ID, useValue: 'es-CL' },
      provideServiceWorker('ngsw-worker.js', {
        enabled: environment.SW,
        registrationStrategy: 'registerWhenStable:30000',
      }),
      importProvidersFrom(
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ToastrModule.forRoot({
          timeOut: 5000,
          positionClass: 'toast-top-right',
          preventDuplicates: true,
          closeButton: true,
          enableHtml: true,
          newestOnTop: true,
          toastClass: 'ngx-toastr',
        }),
      ),
    ],
  }).catch((err) => console.error(err));
});
